import { z } from 'zod';

export const microsoftEmailStatusSchema = z.object({
  provider: z.literal('microsoft365'),
  state: z.enum(['setup-required', 'not-connected', 'connected', 'reconnect-required']),
  setupReady: z.boolean(), canConnect: z.boolean(),
  mailbox: z.string().email().nullable(), connectedAt: z.string().datetime().nullable(),
});
export type MicrosoftEmailStatus = z.infer<typeof microsoftEmailStatusSchema>;
export const microsoftConnectRequestSchema = z.object({}).strict();
export const microsoftCallbackSchema = z.object({
  state: z.string().regex(/^[A-Za-z0-9_-]{43}$/),
  code: z.string().min(1).max(8192).optional(),
  error: z.string().max(200).optional(),
});
